import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { RTEContent } from 'module/ui/components/atoms/rich-text-editor-input/html-content';
import { MultiLineEllipsis, Short01 } from 'module/ui/components/styles';
import styled, { css } from 'styled-components';
import { BlockList } from './block-list/list';

export const SignalName = styled.div`
  ${Short01};
`;
const MutlilineWithEllipsis = styled(RTEContent)<{ line?: number }>`
  ${MultiLineEllipsis};
`;

export const SignalInstruction = styled(MutlilineWithEllipsis).attrs({
  line: 3,
})`
  ${Short01};
`;
export const EmptyMessage = styled(CenterAlignedBox)`
  color: var(--text-secondary);
`;
export const CreateTask = styled(CenterAlignedBox)`
  ${Short01};
`;
export const ReasonField = styled.div`
  display: flex;
  gap: var(--spacing-03);
  flex-wrap: wrap;
`;
export const KnowledgeSources = styled(CenterAlignedBox)<{
  $noContent: boolean;
}>`
  ${Short01};
  > svg {
    color: var(--green-50);
  }
  ${({ $noContent }) =>
    $noContent
      ? css`
          color: var(--text-secondary);
        `
      : ''};
`;
export const ContentWrapper = styled.div`
  max-width: 772px;
  width: 100%;
  ${BlockList} {
    padding-bottom: var(--spacing-10);
  }
`;
export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
  padding: var(--spacing-05) var(--spacing-06) var(--spacing-07);
`;
